import { useMemo } from 'react'

import { Box, Typography } from '@mui/material'
import { ShowcaseEntry, ShowcaseImage } from '@nativewaves/nw-cloud-sdk/showcase'
import { ColumnDef } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { CopyId } from '@shared/components/Table/Fields'

export const useColumns = () => {
  const { t } = useTranslation(['common', 'domain'])

  return useMemo<ColumnDef<ShowcaseEntry>[]>(
    () => [
      {
        accessorKey: 'thumbnail',
        header: t('domain:Showcase.Collection.thumbnail', { count: 1 }),
        meta: {
          sizing: {
            minWidth: 160,
            maxWidth: 180,
          },
          align: 'center',
        },
        cell: ({ getValue }) => (
          <Box
            sx={{ width: 'auto', height: 80, objectFit: 'cover', borderRadius: 1 }}
            component="img"
            src={getValue<ShowcaseImage>().url}
            alt="Logo"
          />
        ),
      },
      {
        accessorKey: 'name',
        header: t('name'),
        meta: {
          sizing: {
            minWidth: 300,
          },
        },
        cell: ({ getValue }) => (
          <Typography variant="inherit" noWrap>
            {getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'id',
        header: t('id'),
        meta: {
          sizing: {
            width: 200,
            px: 2,
          },
        },
        cell: ({ getValue }) => <CopyId id={getValue<string>()} />,
      },
    ],
    [t],
  )
}
